import get from "lodash/get";

export default (state: object): boolean =>
  Boolean(get(state, "auth.token", null));
